import actions from '../actions/pools';
import base from '../../../reducers/base';

const reducer = base(actions.types);
export default reducer;
